import { useDispatch, useSelector } from 'react-redux'
import useBetterLinkTo from '../useBetterLinkTo'
import { useCallback } from 'react'
import { getAddUrl } from '../store/entity/actions'
import { openExternalLink } from '../helpers/link'
import {
  getUrlForEntityWithParams,
  getWeekStart
} from '../components/ListItemButtonOpenCurrentTimesheet'
import { updateMode } from '../screens/EntityAddComponent'
import { useGlobalContext } from '../contexts/GlobalContext'
export const useActionNavigateTo = () => {
  const { setLoading } = useGlobalContext()

  const entityTypes = useSelector((appState) => {
    return appState?.entityTypes?.dataLite?.data ?? []
  })

  const current_user = useSelector((appState) => {
    return appState.users?.user
  })

  const linkTo = useBetterLinkTo()
  const dispatch = useDispatch()

  const actionNavigateTo = useCallback(
    async (navigateTo) => {
      if (typeof navigateTo === 'string') {
        linkTo(navigateTo)
      } else {
        switch (navigateTo?.linkToType) {
          case 'create-entity':
            {
              const entityType = entityTypes.find(
                (e) => e.name == navigateTo?.sourceName
              )
              linkTo(
                getAddUrl(
                  entityType,
                  false,
                  '/entity-list/?type=' + entityType?.name
                )
              )
            }

            break
          case 'view-entity-list':
            {
              const entityType = entityTypes.find(
                (e) => e.name == navigateTo?.sourceName
              )
              linkTo('/entity-list/?type=' + entityType?.name)
            }

            break
          case 'view-report':
            linkTo('/settings/report/' + navigateTo.reportSource?.id, false)
            break
          case 'open-current-timesheet':
            {
              setLoading(true)
              try {
                const week_start = getWeekStart()
                const params = {
                  assignee: current_user.personnel_record.id,
                  personnel: current_user.personnel_record.id,
                  week_start
                }

                const response = await getUrlForEntityWithParams(
                  { name: navigateTo?.sourceName },
                  params,
                  dispatch
                )

                const url = response.uri + '?mode=' + updateMode
                linkTo(url)
              } finally {
                setLoading(false)
              }
            }
            break
          case 'url':
            openExternalLink(navigateTo?.url)
            break
        }
      }
    },
    [linkTo, getAddUrl, openExternalLink, entityTypes]
  )

  return { actionNavigateTo }
}
